import React, { useEffect, useState } from 'react';
import { fetchData } from '../utils/runtime.js';

export default function MaintenanceBanner() {
    const [active, setActive] = useState(false);

    useEffect(() => {
        fetchData('/api/maintenance')
            .then((data) => {
                if (data && typeof data.maintenance !== 'undefined') {
                    setActive(Boolean(data.maintenance));
                }
            })
            .catch((err) => console.error('Failed to load maintenance status', err));
    }, []);

    if (!active) return null;

    return (
        <div className="fixed top-0 left-0 w-full bg-red-600 text-white text-center text-sm z-50">
            The site is currently under maintenance.
        </div>
    );
}
